// extracted by mini-css-extract-plugin
export default {"connection":"styles_connection__wdLcY","good":"styles_good__hHmL5","normal":"styles_normal__nz9ZK","bad":"styles_bad__eP1um"};